/* eslint-disable no-unused-vars */
/* eslint-disable no-inner-declarations */
/** ja slider */

// import Swiper from "Vendor/swiper.js";
// import $ from "jquery";

import Swiper, { Autoplay, Scrollbar } from "swiper";

let swiperTimetravel = undefined;

export default function timetravelSlider() {
	if (!$(".timetravel-slider").length) return;
	// let windowWidth = $(window).width();

	// if (windowWidth <= 991) {

	// When Carousel exists
	if (timetravelSlider) {
		function initSliderTimetravel() {
			let $obj = $(".timetravel-slider");

			const swiperCarousels =
				document.querySelectorAll(".timetravel-swiper");

			swiperCarousels.forEach((carouselContainer) => {
				let $this = $(carouselContainer);

				const carouselPagination =
					carouselContainer.querySelector(".swiper-pagination");

				const carouselPrevButton =
					carouselContainer.querySelector(".swiper-button-prev") ||
					carouselContainer.parentElement.querySelector(
						".swiper-button-prev" // <-- this is how you can have the Prev Button outside the swiper container
					);

				const carouselNextButton =
					carouselContainer.querySelector(".swiper-button-next") ||
					carouselContainer.parentElement.querySelector(
						".swiper-button-next" // <-- this is how you can have the Next Button outside the swiper container
					);

				if (!$this.hasClass("swiper-horizontal")) {
					swiperTimetravel = new Swiper(carouselContainer, {
						modules: [Autoplay, Scrollbar],
						slideToClickedSlide: true,
						preloadImages: true,
						grabCursor: true,
						spaceBetween: 0,
						slidesPerView: 1,
						centeredSlides: true,
						// lazy: true,
						loop: false,
						autoplay: {
							delay: 3000,
							pauseOnMouseEnter: true,
							stopOnLastSlide: false
						},
						lazy: {
							loadPrevNext: true,
							loadPrevNextAmount: 10,
						},
						scrollbar: {
							el: '.swiper-scrollbar',
							// Makes the Scrollbar Draggable
							draggable: true,
							// Snaps slider position to slides when you release Scrollbar
							snapOnRelease: true,
							// Size (Length) of Scrollbar Draggable Element in px
							dragSize: 'auto',
						},
						breakpoints: {
							768: {
								// slidesPerView: 'auto',
								// slidesPerGroup: 1,
								// centeredSlides: true,
								// spaceBetween: 10,
								// loop: true,
								// noSwiping: false
							},
							992: {
								// slidesPerView: 'auto',
								// slidesPerGroup: 1,
								// centeredSlides: true,
								// spaceBetween: 10,
								// loop: true,
								noSwiping: false,
							},
						},
					});
				}
			});
		}

		initSliderTimetravel();
	}
}
